<template>
  <div class="task-view-container">
    <div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="1">基本信息</el-menu-item>
        <el-menu-item index="2">申请审核</el-menu-item>
        <el-menu-item index="3">任务认领</el-menu-item>
        <el-menu-item index="4" v-if="baseInfoForm.rwTxlx == '技术'"
          >认领审核</el-menu-item
        >
        <el-menu-item index="5">成果物审核</el-menu-item>
        <el-menu-item index="6">任务奖励</el-menu-item>
      </el-menu>
    </div>
    <!-- 基本信息 -->
    <div v-show="activeIndex == '1'" class="base-info">
      <div class="row">
        <div class="title">任务进度</div>
        <div class="step-wrap card">
          <el-steps :active="stepActive">
            <el-step
              :title="item.name"
              :description="item.time"
              v-for="(item, index) in progressList"
              :key="index"
              :status="
                item.status == 1
                  ? 'finish '
                  : item.status == 0
                  ? 'error '
                  : 'wait'
              "
            ></el-step>
          </el-steps>
        </div>
      </div>
      <div class="row">
        <div class="title">申请人信息</div>
        <div class="card apply-info">
          <div class="item">
            <div>申请人姓名：</div>
            <div>{{ baseInfoForm.sqName }}</div>
          </div>
          <div class="item">
            <div>申请人职位：</div>
            <div>{{ baseInfoForm.zw }}</div>
          </div>
          <div class="item">
            <div>申请人部门：</div>
            <div>{{ baseInfoForm.bmmc }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="title">任务信息</div>
        <div class="card">
          <el-form
            ref="form"
            :model="baseInfoForm"
            label-width="80px"
            class="clearfix"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务编号：" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.rwbh"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="任务标题：" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.title"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务所属部门：" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.rwBmmc"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="任务所属条线：" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.rwTxlx"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务类型：" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.rwName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="任务子类：" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.rwSun"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item
                  label="标准积分"
                  prop="jf"
                  key="5"
                  label-width="150px"
                >
                  <el-input-number
                    v-model="baseInfoForm.jf"
                    :min="0"
                    class="reward-input"
                    :max="99999"
                    disabled
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务说明：" label-width="150px">
                  <div id="wangEditor_view"></div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预期成果说明：" label-width="150px">
                  <div id="wangEditor2_view"></div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="任务附件：" label-width="150px">
                  <div v-for="item in baseInfoForm.taskFile" :key="item.fileId">
                    <el-link @click="openPreview(item)" type="primary">
                      {{ item.fileName }}
                    </el-link>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务结束时间：" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.jsrq"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="计划总工时(人/日):" label-width="150px">
                  <el-input disabled v-model="baseInfoForm.gs"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="认领对象：" label-width="150px">
                <el-input disabled v-model="baseInfoForm.rldxString"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="备注：" label-width="150px">
                <el-input
                  type="textarea"
                  disabled
                  :rows="4"
                  v-model="baseInfoForm.bz"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row v-if="baseInfoForm.zzly">
              <el-form-item label="任务终止理由：" label-width="150px">
                <el-input
                  type="textarea"
                  disabled
                  :rows="4"
                  v-model="baseInfoForm.zzly"
                ></el-input>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 申请审核 -->
    <div v-show="activeIndex == '2'" class="task-receive">
      <div class="tips">申请审核</div>
      <div class="steps">
        <div v-for="(item, index) in sqshList" :key="index">
          <el-button
            :type="sqshBtnActive == index ? 'primary ' : ''"
            @click="handleClickRevier(index)"
          >
            {{ item.xm }}/
            <span
              :style="{
                color:
                  item.status == '通过'
                    ? sqshBtnActive == index
                      ? '#fff'
                      : '#409EFF'
                    : '#ff0000',
              }"
              >{{ item.status }}</span
            >
          </el-button>
        </div>
        <div>
          <!-- <div>
            <el-button
              @click="handleClickRevier(rlReviewers.length)"
              :type="btnActive == rlReviewers.length ? 'primary ' : ''"
              >{{ user.xm }}</el-button
            >
          </div>-->
        </div>
      </div>
      <div class="clearfix rlr">
        <div class="label">审核意见</div>
        <div class="input">
          <el-input
            type="textarea"
            maxlength="500"
            rows="6"
            disabled
            v-model="sqshbz"
          ></el-input>
        </div>
      </div>
    </div>
    <!-- 任务认领 -->
    <div v-show="activeIndex == '3'" class="task-receive">
      <div class="tips">任务认领</div>
      <el-table
        :max-height="height"
        :data="taskReceiveList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="认领人"
          align="left"
          prop="xm"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="认领人部门"
          align="left"
          prop="bmmc"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="认领人职位"
          align="left"
          prop="gwmc"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作人"
          align="left"
          prop="xzr"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作开始时间"
          align="left"
          prop="qsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作结束时间"
          align="left"
          prop="jsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="认领时间"
          align="left"
          prop="createtime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="taskReceiveTotal > 0"
        :total="taskReceiveTotal"
        :page.sync="taskReceiveListQuery.page"
        :limit.sync="taskReceiveListQuery.pageSize"
        @pagination="taskReceiveGetList"
      />
    </div>
    <!-- 认领审核 -->
    <div v-show="activeIndex == '4'" v-if="baseInfoForm.rwTxlx == '技术'">
      <div class="tips">认领审核</div>
      <el-table
        :max-height="height"
        v-loading="rwrlListLoading"
        :data="rwrlList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="认领人"
          align="left"
          prop="xm"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="审核状态"
          align="left"
          prop="statusString"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="审核人"
          align="left"
          prop="shname"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="审核意见"
          align="left"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="toRlshDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="rwrlTotal > 0"
        :total="rwrlTotal"
        :page.sync="rwrlListQuery.page"
        :limit.sync="rwrlListQuery.pageSize"
        @pagination="getRlshList"
      />
    </div>
    <!-- 成果物审核 -->
    <div v-show="activeIndex == '5'">
      <div class="tips">成果物审核</div>
      <el-table
        :max-height="height"
        :data="cgwshList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="提交人"
          align="left"
          prop="xm"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="成果物"
          align="left"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="toCgwsh(scope.row)">更多</el-button>
          </template>
        </el-table-column>

        <el-table-column
          label="提交时间"
          align="left"
          prop="updatetime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="审核状态"
          align="left"
          prop="status"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="操作"
          align="left"
          prop="name"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="toCgwshDetail(scope.row)"
              >查看审核</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="cgwshTotal > 0"
        :total="cgwshTotal"
        :page.sync="cgwshList.page"
        :limit.sync="cgwshList.pageSize"
        @pagination="getCgwshList"
      />
    </div>
    <!-- 任务奖励 -->
    <div v-show="activeIndex == '6'">
      <div class="tips">任务评分</div>
      <el-table
        :max-height="height"
        :data="rwjlList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="提交人"
          align="left"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="提交人类型"
          align="left"
          prop="lx"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="审核状态"
          align="left"
          prop="status"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="积分"
          align="left"
          prop="jf"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="实际工作量"
          align="left"
          prop="sjgzl"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="评价内容"
          align="left"
          prop="pj"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="rwjlTotal > 0"
        :total="rwjlTotal"
        :page.sync="rwjlListQuery.page"
        :limit.sync="rwjlListQuery.pageSize"
        @pagination="getRwjlList"
      />
    </div>
    <div class="bottom-btn">
      <div class="btn-item" @click="btnFlag = !btnFlag">
        <span>
          <img src="../../img/menu_bottom_1.svg" alt />
        </span>
        <span v-text="btnFlag ? '收起' : '展开'"></span>
      </div>
      <span v-show="btnFlag">
        <div class="btn-item" @click="handleClose">
          <span>
            <img src="../../img/menu_bottom_2.svg" alt />
          </span>
          <span>返回</span>
        </div>
        <div
          class="btn-item"
          @click="rwzzDialog = true"
          v-if="
            (baseInfoForm.control.isrwsqr || baseInfoForm.control.isadmin) &&
            (baseInfoForm.status == 1 ||
              baseInfoForm.status == 3 ||
              baseInfoForm.status == 4 ||
              baseInfoForm.status == 5 ||
              baseInfoForm.status == 6 ||
              baseInfoForm.status == 7 ||
              baseInfoForm.status == 8)
          "
        >
          <span>
            <img src="../../img/menu_bottom_3.svg" alt />
          </span>
          <span>终止</span>
        </div>
        <div
          class="btn-item"
          @click="taskEditDialog = true"
          v-if="
            (baseInfoForm.control.isrwsqr || baseInfoForm.control.isadmin) &&
            baseInfoForm.status != 9 &&
            baseInfoForm.status != 10
          "
        >
          <span>
            <img src="../../img/menu_bottom_4.svg" alt />
          </span>
          <span>编辑</span>
        </div>
        <div
          class="btn-item"
          @click="taskApplyAuditDialog = true"
          v-if="
            (baseInfoForm.control.isrwshr || baseInfoForm.control.isadmin) &&
            baseInfoForm.status == 1
          "
        >
          <span>
            <img src="../../img/menu_bottom_5.svg" alt />
          </span>
          <span>任务审核</span>
        </div>
        <div
          class="btn-item"
          @click="taskClaimDialog = true"
          v-if="
            (baseInfoForm.control.isrldx || baseInfoForm.control.isadmin) &&
            baseInfoForm.control.isrl != 1 &&
            ((baseInfoForm.txlx == 1 &&
              baseInfoForm.isbtg != 1 &&
              (baseInfoForm.status == 3 ||
                baseInfoForm.status == 5 ||
                baseInfoForm.status == 6)) ||
              (baseInfoForm.txlx != 1 &&
                (baseInfoForm.status == 3 ||
                  baseInfoForm.status == 6 ||
                  baseInfoForm.status == 7)))
          "
        >
          <span>
            <img src="../../img/menu_bottom_6.svg" alt />
          </span>
          <span>任务认领</span>
        </div>
        <div
          class="btn-item"
          @click="taskClaimAuditDialog = true"
          v-if="
            (baseInfoForm.control.isrlshr || baseInfoForm.control.isadmin) &&
            baseInfoForm.control.isshrsz &&
            baseInfoForm.txlx == 1 &&
            baseInfoForm.status == 4
          "
        >
          <span>
            <img src="../../img/menu_bottom_7.svg" alt />
          </span>
          <span>认领审核</span>
        </div>
        <div
          class="btn-item"
          @click="taskClaimSettingDialog = true"
          v-if="
            baseInfoForm.control.isadmin &&
            baseInfoForm.control.isshrsz == 0 &&
            baseInfoForm.txlx == 1 &&
            baseInfoForm.status == 4
          "
        >
          <span>
            <img src="../../img/menu_bottom_8.svg" alt />
          </span>
          <span>认领审核设置</span>
        </div>
        <div
          class="btn-item"
          @click="handleUpload()"
          v-if="
            (baseInfoForm.control.isrwrlr ||
              baseInfoForm.control.isrwxzr ||
              baseInfoForm.control.isadmin) &&
            (baseInfoForm.status == 7 || baseInfoForm.status == 8)
          "
        >
          <span>
            <img src="../../img/menu_bottom_9.svg" alt />
          </span>
          <span>
            {{ baseInfoForm.rwTxlx === "技术" ? "任务完成" : "成果物上传" }}
          </span>
        </div>
        <div
          class="btn-item"
          @click="toCgwList()"
          v-if="
            (baseInfoForm.control.iscgwshr || baseInfoForm.control.isadmin) &&
            (baseInfoForm.status == 7 || baseInfoForm.status == 8)
          "
        >
          <span>
            <img src="../../img/menu_bottom_10.svg" alt />
          </span>
          <span>
            {{ baseInfoForm.rwTxlx === "技术" ? "任务完成确认" : "成果物审核" }}
          </span>
        </div>
        <div
          class="btn-item"
          @click="reward(mxParams.id)"
          v-if="
            (baseInfoForm.control.isrwsqr || baseInfoForm.control.isadmin) &&
            baseInfoForm.control.isjfjl == 1
          "
        >
          <span>
            <img src="../../img/menu_bottom_11.svg" alt />
          </span>
          <span>积分奖励</span>
        </div>
      </span>
    </div>
    <!-- 认领审核列表弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="审核意见"
      :visible.sync="shyjDialog"
      width="80%"
      v-if="shyjDialog"
      id="mx-dialog"
    >
      <el-table
        :max-height="height"
        :data="shyjData"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="审核人"
          align="left"
          prop="xm"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="审核状态"
          align="left"
          prop="statusstring"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="审核意见"
          align="left"
          prop="bz"
          min-width="150px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="审核时间"
          align="left"
          prop="updatetime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </el-dialog>
    <!-- 成果物列表更多（成果物审核） -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="成果物审核"
      :visible.sync="cgwshDetailDialog"
      width="80%"
      v-if="cgwshDetailDialog"
      id="mx-dialog"
    >
      <el-tabs>
        <el-tab-pane
          v-for="(item, index) in cgw.reviewList"
          :label="'第' + (cgw.reviewList.length - index) + '轮评审'"
          :key="index"
        >
          <el-tabs type="card">
            <el-tab-pane v-for="(it, i) in item.reviewList" :key="i">
              <span slot="label">
                {{ it.xm + "/" }}
                <el-tag type="success" size="small" v-show="it.status === 1"
                  >通过</el-tag
                >
                <el-tag type="danger" size="small" v-show="it.status === 0"
                  >不通过</el-tag
                >
                <el-tag size="small" v-show="it.status === 2">未审核</el-tag>
              </span>
              <el-card class="box-card" v-show="it.status !== 2" shadow="hover">
                <div slot="header" class="clearfix">
                  <span>{{ it.sj }}</span>
                </div>
                <div class="text item">{{ it.bz }}</div>
              </el-card>
              <!-- <div style="margin: 10px 0">
                <el-tag v-show="it.status !== 2">{{it.sj}}</el-tag>
                {{it.status !== 2? ( " " +it.bz) :""}}
              </div>-->
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
      <div v-show="cgw.cgwPzYtjList.length > 0">
        <div class="tips">成果物批注附件</div>
        <el-table
          :data="cgw.cgwPzYtjList"
          size="mini"
          highlight-current-row
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="上传人"
            align="left"
            prop="xm"
            min-width="80px"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            label="上传时间"
            align="left"
            prop="uploadtime"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            prop="filename"
            label="文件名字"
            min-width="250px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div>
                <el-link @click="openPreview(scope.row)" type="primary">{{
                  scope.row.filename + scope.row.extname
                }}</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="大小"
            align="left"
            prop="filesize"
            min-width="100px"
            :show-overflow-tooltip="true"
          />

          <el-table-column label="操作" align="left" prop="name">
            <template slot-scope="scope">
              <el-button @click="downloadFile(scope.row)" type="text"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="成果物"
      :visible.sync="cgwshDialog"
      width="80%"
      v-if="cgwshDialog"
      id="mx-dialog"
    >
      <div class="tips">成果物</div>
      <el-table
        v-show="cgw.cgwYtjList.length > 0"
        :data="cgw.cgwYtjList"
        size="mini"
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="xm"
          min-width="90px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{
              scope.row.ygbh === scope.row.uploader
                ? scope.row.xm + "(认领人)"
                : scope.row.xm + "(协作人)"
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          prop="filename"
          label="文件名字"
          min-width="200px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="openPreview(scope.row)" type="primary">{{
                scope.row.filename + scope.row.extname
              }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="备注"
          align="left"
          prop="bz"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" align="left" prop="name">
          <template slot-scope="scope">
            <el-button @click="downloadFile(scope.row)" type="text"
              >下载</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </el-dialog>

    <!-- 任务终止 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="任务终止"
      :visible.sync="rwzzDialog"
      append-to-body
      width="80%"
    >
      <el-form ref="rules" :model="rwzzForm" label-width="100px" id="save-form">
        <el-input
          type="textarea"
          placeholder="请输入终止理由"
          :rows="8"
          maxlength="500"
          show-word-limit
          v-model="rwzzForm.zzly"
        ></el-input>
        <div class="row">
          <div class="title">任务信息</div>
          <div class="card apply-info">
            <div class="item">
              <div>任务编号：</div>
              <div>{{ baseInfoForm.rwbh }}</div>
            </div>
          </div>
          <div class="card apply-info">
            <div class="item">
              <div>任务标题：</div>
              <div>{{ baseInfoForm.title }}</div>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="small"
          @click="saveZzly()"
          style="margin-right: 15px"
          >确 定</el-button
        >
        <el-button size="small" @click="rwzzDialog = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 任务编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑任务"
      :visible.sync="taskEditDialog"
      width="80%"
      append-to-body
      v-if="taskEditDialog"
      id="mx-dialog"
    >
      <TaskEdit
        ref="editTask"
        :mxParams="mxParams"
        @giveFather="getSon"
        v-if="taskEditDialog"
      ></TaskEdit>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="editTask()"
          v-if="baseInfoForm.status != 2"
          >提交</el-button
        >
        <el-button type="primary" @click="editTask()" v-else
          >重新提交审核</el-button
        >
        <el-button
          type="primary"
          @click="resetEdit"
          v-if="baseInfoForm.status == 1"
          >重置</el-button
        >
        <el-button @click="taskEditDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 任务审核 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="任务审核"
      :visible.sync="taskApplyAuditDialog"
      width="80%"
      v-if="taskApplyAuditDialog"
      append-to-body
      id="applyAudit-dialog"
    >
      <TaskApplyAudit
        v-if="taskApplyAuditDialog"
        :mxParams="mxParams"
        @giveFather="getSon"
      ></TaskApplyAudit>
    </el-dialog>
    <!-- 任务认领 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="任务认领"
      :visible.sync="taskClaimDialog"
      width="80%"
      v-if="taskClaimDialog"
      append-to-body
      id="mx-dialog"
    >
      <TaskClaim
        @giveFather="getSon"
        :mxParams="mxParams"
        ref="rwrlForm"
      ></TaskClaim>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRwrl">认领</el-button>
        <el-button @click="taskClaimDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 认领审核 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="认领审核"
      :visible.sync="taskClaimAuditDialog"
      width="80%"
      v-if="taskClaimAuditDialog"
      id="mx-dialog"
      append-to-body
    >
      <TaskClaimAudit
        :mxParams="mxParams"
        ref="taskClaimAuditForm"
        @giveFather="getSon"
      ></TaskClaimAudit>
      <div slot="footer" class="dialog-footer">
        <div v-if="task.rwshBtnPermission" style="display: inline-block">
          <el-button type="primary" @click="saveRlsh(1)">通过</el-button>
          <el-button type="danger " @click="saveRlsh(0)">驳回</el-button>
        </div>
        <el-button @click="taskClaimAuditDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 认领审核设置 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="认领审核设置"
      :visible.sync="taskClaimSettingDialog"
      width="80%"
      v-if="taskClaimSettingDialog"
      id="mx-dialog"
      append-to-body
    >
      <TaskClaimSetting
        :mxParams="mxParams"
        ref="taskClaimSettingForm"
        @giveFather="getSon"
      ></TaskClaimSetting>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRlshrtz">保存</el-button>
        <el-button @click="taskClaimSettingDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 成果物上传 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="txlx === '技术' ? '任务完成' : '成果物上传'"
      :visible.sync="cgwUploadDialog"
      width="80%"
      top="20px"
      v-if="cgwUploadDialog"
      append-to-body
    >
      <CgwUpload
        v-if="cgwUploadDialog"
        ref="uploadForm"
        :mxParams="mxParams"
        @hideDialog="closeCgwUploadDialog"
      ></CgwUpload>
    </el-dialog>
  </div>
</template>
<script>
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import wangEditor from "wangeditor";
import {
  getRwrlList,
  getBaseInfoDetail,
  getRwjlList,
  getRlshList,
  getCgwshList,
  getSqshList,
  rwzzUpdate,
  getTaskProgress,
} from "@/api/task.js";

import CgwUpload from "../cgw/cgwUpload";
import rlmx from "./rlmx.vue";
import TaskAdd from "./taskAdd.vue";
import TaskEdit from "./taskEdit.vue";
import TaskApplyAudit from "./taskApplyAudit.vue";
import TaskClaim from "./taskClaim/taskClaim.vue";
import TaskClaimSetting from "./taskClaim/taskClaimSetting.vue";
import TaskClaimAudit from "./taskClaim/taskClaimAudit.vue";

export default {
  name: "taskView",
  computed: {
    ...mapGetters(["task", "cgw"]),
  },
  components: {
    Pagination,
    rlmx,
    TaskAdd,
    TaskEdit,
    TaskClaim,
    CgwUpload,
    TaskApplyAudit,
    TaskClaimSetting,
    TaskClaimAudit,
  },

  props: ["mxParams"],

  data() {
    return {
      height: 800,
      activeIndex: "1",
      stepActive: 0,
      baseInfoForm: {
        status: null,
        control: {},
      },
      progressList: [],
      editor: null,
      editor2: null,
      //申请审核
      sqshList: [],
      sqshListQuery: {
        id: null,
      },
      sqshbz: null,
      sqshBtnActive: 0,
      //任务认领
      taskReceiveList: [],
      taskReceiveListQuery: {
        id: null,
        txlx: null,
        page: 1,
        pageSize: 10,
      },
      taskReceiveTotal: 0,
      //认领审核
      rwrlListLoading: false,
      rwrlList: [],
      rwrlListQuery: {
        id: null,
        page: 1,
        pageSize: 10,
      },
      rwrlTotal: 0,
      shyjDialog: false,
      shyjData: [],
      //成果物审核
      cgwshList: [],
      cgwshListLoading: false,
      cgwshListQuery: {
        id: null,
        page: 1,
        pageSize: 10,
      },
      cgwshTotal: 0,
      // 任务奖励
      rwjlList: [],
      rwjlListQuery: {
        id: null,
        page: 1,
        pageSize: 10,
      },
      rwjlTotal: 0,
      btnFlag: true,

      //底部按钮
      parentDialog: false,
      // 任务终止
      rwzzDialog: false,
      rwzzForm: {
        id: "",
        zzly: "",
        rwbh: "",
        title: 0,
      },
      //任务编辑
      taskEditDialog: false,
      cgwUploadDialog: false,
      taskViewDialog: false,
      taskAddDialog: false,
      taskApplyAuditDialog: false,
      taskClaimDialog: false,
      taskClaimSettingDialog: false,
      taskClaimAuditDialog: false,
      rwshBtnPermission: true,
      txlx: null,
      cgwshDialog: false,
      cgwshDetailDialog: false,
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor_view`);
    let editor2 = new wangEditor(`#wangEditor2_view`);
    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;

    setTimeout(() => {
      const w = document.querySelector(".bottom-btn").clientWidth;
      document.querySelector(".bottom-btn").style.marginLeft = `${-w / 2}px`;
      document.querySelector(".bottom-btn").style.visibility = `visible`;
      document.querySelector(".bottom-btn").style.left = "50%";
    }, 1000);
  },
  methods: {
    getList() {
      this.getBaseInfo();
      this.taskReceiveGetList();
      this.getRwjlList();
      this.getRlshList();
      this.getCgwshList();
      this.getSqshList();
      this.getTaskProgress();
    },
    handleSelect(key) {
      this.activeIndex = key;
    },
    editorConfig(editor, needMenu) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      // editor.config.uploadImgServer = window.g.apiUrl + '/common/uploadForumFile'
      // editor.config.uploadImgHeaders = {
      //   "x-token": localStorage.getItem("token"), // 设置请求头
      // };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      if (needMenu) {
        editor.config.excludeMenus = ["video", "link", "code"];
      } else {
        editor.config.excludeMenus = [
          "head",
          "bold",
          "fontSize",
          "fontName",
          "italic",
          "underline",
          "strikeThrough",
          "indent",
          "lineHeight",
          "foreColor",
          "backColor",
          "link",
          "list",
          "todo",
          "justify",
          "quote",
          "emoticon",
          "image",
          "video",
          "table",
          "code",
          "splitLine",
          "undo",
          "redo",
        ];
      }

      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   // return;

      //   if (editor.txt.html() == "") {
      //     editor.disable();
      //   }
      // };

      editor.create();
      // editor.disable();
      editor.fullScreen = true;
      return editor;
    },
    taskReceiveGetList() {
      this.taskReceiveListQuery.id = this.mxParams.id;
      this.taskReceiveListQuery.txlx = this.mxParams.txlx;

      getRwrlList(this.taskReceiveListQuery).then((res) => {
        if (res.code == 0) {
          this.taskReceiveList = res.data;
          this.taskReceiveTotal = res.count;
        }
      });
    },
    getBaseInfo() {
      getBaseInfoDetail({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          this.baseInfoForm = res.data;
          this.editor.txt.html(this.baseInfoForm.rwsm);
          this.editor2.txt.html(this.baseInfoForm.yqjg);
        }
      });
    },
    getSqshList() {
      this.sqshListQuery.id = this.mxParams.id;
      getSqshList(this.sqshListQuery).then((res) => {
        if (res.code == 0) {
          this.sqshList = res.data;
          if (this.sqshList && this.sqshList.length > 0) {
            this.sqshbz = this.sqshList[0].bz;
          }
        }
      });
    },
    getTaskProgress() {
      getTaskProgress({ taskId: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          this.progressList = res.data;
          for (let i in this.progressList) {
            if (this.progressList[i].status != "1") {
              this.stepActive = i;
              return;
            }
          }
        }
      });
    },
    handleClickRevier(index) {
      this.sqshbz = this.sqshList[index].bz;
      this.sqshBtnActive = index;
    },
    getRwjlList() {
      this.rwjlListQuery.id = this.mxParams.id;
      getRwjlList(this.rwjlListQuery).then((res) => {
        if (res.code == 0) {
          this.rwjlList = res.data;
          this.rwjlTotal = res.count;
        }
      });
    },
    getRlshList() {
      this.rwrlListQuery.id = this.mxParams.id;
      getRlshList(this.rwrlListQuery).then((res) => {
        if (res.code == 0) {
          this.rwrlList = res.data;
          this.rwrlTotal = res.count;
        }
      });
    },
    getCgwshList() {
      this.cgwshListQuery.id = this.mxParams.id;
      getCgwshList(this.cgwshListQuery).then((res) => {
        if (res.code == 0) {
          this.cgwshList = res.data;
          this.cgwshTotal = res.count;
        }
      });
    },

    toRlshDetail(row) {
      this.shyjData = row.shyjList;
      this.shyjDialog = true;
    },
    openPreview(row) {
      const url = row.fileBrowse ? row.fileBrowse : row.previewurl;
      window.open(url);
    },
    handleClose() {
      this.$emit("giveFather", this.parentDialog);
    },
    giveFather() {
      this.parentDialog = false;
    },
    //任务终止
    saveZzly() {
      this.rwzzForm.id = this.mxParams.id;
      const params = {
        id: this.rwzzForm.id,
        zzly: this.rwzzForm.zzly,
      };
      rwzzUpdate(params).then((res) => {
        if (res.code == 0) {
          this.dialogFlag2 = false;
          this.$message.success(res.msg);
          this.$store.dispatch(
            "task/fetchTaskListAction",
            this.task.taskList.params
          );
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getSon(temp) {
      this.dialogFlag1 = false;
      this.dialogFlag2 = false;
      this.cgwUploadDialog = false;
      this.taskApplyAuditDialog = false;
      this.taskClaimSettingDialog = false;
      this.taskClaimAuditDialog = false;
      this.taskAddDialog = temp;
      this.taskEditDialog = temp;
      this.taskClaimDialog = temp;
    },
    //任务编辑
    editTask() {
      this.$refs.editTask.submitUpload();
      this.getList();
    },
    //任务编辑页重置
    resetEdit() {
      this.$refs.editTask.resetFrom();
    },
    //任务认领保存
    saveRwrl() {
      this.$refs.rwrlForm.saveRwrl();
      this.getList();
    },
    // 打开成果物上传页
    handleUpload() {
      const { rwbh, rwTxlx, title } = this.baseInfoForm;
      this.mxParams = { id: this.mxParams.id, txlx: rwTxlx, title, rwbh };
      this.txlx = rwTxlx;
      this.cgwUploadDialog = true;
    },
    //跳转成果物审核列表
    toCgwList() {
      this.$router.push({
        name: "cgwList",
      });
    },
    // 跳转积分奖励
    reward(taskId) {
      this.$router.push({
        name: "reward",
        params: {
          taskId: taskId,
        },
      });
    },
    toCgwsh(row) {
      this.cgwshDialog = true;
      this.$store.dispatch("cgw/fetchCgwYtjListAction", {
        rlId: row.id,
      });
      this.$store.dispatch("cgw/fetchCgwPzYtjListAction", {
        rlId: row.id,
      });
      this.$store.dispatch("cgw/fetchCgwReviewAction", {
        rlId: row.id,
      });
    },
    toCgwshDetail(row) {
      this.cgwshDetailDialog = true;
      this.$store.dispatch("cgw/fetchCgwYtjListAction", {
        rlId: row.id,
      });
      this.$store.dispatch("cgw/fetchCgwPzYtjListAction", {
        rlId: row.id,
      });
      this.$store.dispatch("cgw/fetchCgwReviewAction", {
        rlId: row.id,
      });
    },
    downloadFile(row) {
      const filePath = row.url;
      const fileName = row.filename + row.extname;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
  },
};
</script>
<style lang="less" scoped>
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.task-view-container {
  .base-info {
    .row {
      margin-top: 15px;
      .title {
        height: 44px;
        background-color: #d7d7d7;
        padding-left: 15px;
        // font-size: 16px;
        line-height: 44px;
        margin-bottom: 15px;
      }
      .step-wrap {
        padding: 0 10%;
      }
      .apply-info {
        display: flex;
        height: 44px;
        line-height: 44px;
        .item {
          padding: 0 50px;
        }
        div {
          display: flex;
        }
      }
    }
  }
}
.bottom-btn {
  position: fixed;
  visibility: hidden;
  bottom: 10px;
  display: flex;
  background-color: #717171;
  color: #fff;
  height: 44px;
  line-height: 44px;
  z-index: 100005;
  border-radius: 10px;
  > span {
    display: flex;
    height: 44px;
    line-height: 44px;
  }
  .btn-item {
    padding: 0 8px;
    display: flex;
    justify-items: center;
    cursor: pointer;
    span:nth-of-type(1) {
      margin-right: 10px;
    }
    img {
      vertical-align: text-bottom;
      width: 16px;
    }
  }
}
.rlr {
  display: flex;
  .label {
    width: 80px;
    line-height: 40px;
    text-align: right;
    padding-right: 10px;
  }
  .input {
    width: calc(100% - 80px);
  }
}

.steps {
  display: flex;
  margin-bottom: 15px;
  margin-left: 80px;
  > div {
    margin-right: 15px;
  }
}

//任务终止

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
</style>
